
<template>
  <span>

    <PostListImmo ref="child" v-if="this.universe === 'IMMO'" v-on:diffuse-later="diffuseLaterEvent($event)"></PostListImmo>
    <PostListVo ref="child" v-else v-on:diffuse-later="diffuseLaterEvent($event)"></PostListVo>

    <el-dialog :title="$t('posts.list.diffuseLater.title')" :visible.sync="showDiffuseLaterModal" @opened="$refs.diffuseLaterPicker.focus()">

        {{$t('posts.list.diffuseLater.text')}} <br>

        <span class="font-secondary" style="font-size: small">{{$t('posts.list.diffuseLater.subText')}}</span> <br><br>

        <el-date-picker
                ref="diffuseLaterPicker"
                v-model="diffuseLaterDate"
                :picker-options="pickerOptions"
                format="dd/MM/yyyy"
        ></el-date-picker>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showDiffuseLaterModal = false">{{ $t("posts.dialog.cancel") }}</el-button>
            <el-button @click="diffuseLater()" type="primary">{{ $t("posts.dialog.confirm") }}</el-button>
        </span>

    </el-dialog>
    <ButtonScrollToTop @goToTop="goToTop" @scroll="handleScroll" v-if="buttonIsVisible" />
  </span>
</template>

<script>
import { patchPost } from '@/services/posts'
import { getObjectTypes } from '@/services/postsData'
import ElButton from '../../../components/Button'

import PostListImmo from './PostsListImmo'
import PostListVo from './PostsListVo'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import ButtonScrollToTop from '@/components/ui/ButtonScrollToTop'
import { buttonScrollToTopMixin } from '@/mixins/buttonScrollToTopMixin'

export default {
  name: 'PostsList',
  mixins: [buttonScrollToTopMixin],
  components: { ButtonScrollToTop, ElButton, PostListImmo, PostListVo },
  data () {
    return {
      showDiffuseLaterModal: false,
      diffuseLaterDate: null,
      diffuseLaterId: null,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser', 'getUser']),
    universe () {
      return this.getSitimmoUser.univers
    },
    isPromoteur () {
      return this.getSitimmoUser.metier === 'PROMOTEUR'
    },
    username () {
      return this.getUser.username
    },
    codeFlux () {
      return 'SAISIE_' + this.universe
    }
  },
  methods: {
    ...mapMutations('posts', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'resetFilter'
    ]),
    formatDate (date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
    async doFilter (type) {
      switch (type) {
        case 'reset':
          this.resetFilter()
          this.setAnnonceParente(null)
          this.objectTypes = await getObjectTypes(this.filter.annonceParente)
          break
        case 'archived':
          this.setFilter({
            dateCreationLt: this.$moment()
              .subtract(6, 'months')
              .toDate()
          })
          break
        case 'enable':
          this.filter.annoncesActivees = true
          this.filter.annoncesDesactivees = null
          this.filter.annoncesModeles = null
          this.setFilter(this.filter)
          break
        case 'disabled':
          this.filter.annoncesDesactivees = true
          this.filter.annoncesActivees = null
          this.filter.annoncesModeles = null
          this.setFilter(this.filter)
          break
        case 'modeles':
          this.filter.annoncesActivees = null
          this.filter.annoncesDesactivees = null
          this.filter.annoncesModeles = true
          this.setFilter(this.filter)
          break
      }
    },
    async setAnnonceParente (idAnnonceParente) {
      this.setFilter({ annonceParente: idAnnonceParente })
      this.objectTypes = await getObjectTypes(idAnnonceParente)
    },
    async diffuseLater () {
      this.$ga.event('annonce', 'clic', 'valider_programmation', this.getSitimmoUser.id)
      const result = await patchPost({ id: this.diffuseLaterId, DATE_DEBUT_DIFFUSION: this.formatDate(this.diffuseLaterDate) }, this.getSitimmoUser.login, this.codeFlux)
      this.showDiffuseLaterModal = false

      if (result.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }

      // fetchlist on children
      await this.$refs.child.fetchList()

      return this.$message({ message: this.$t('posts.list.diffuseLater.diffusionConfirmedFirstPart') + this.formatDate(this.diffuseLaterDate) + this.$t('posts.list.diffuseLater.diffusionConfirmedSecondPart'), type: 'success' })
    },
    diffuseLaterEvent (data) {
      this.showDiffuseLaterModal = true
      this.diffuseLaterId = data.id
      this.diffuseLaterDate = data.diffuseLaterDate ? moment(data.diffuseLaterDate.valeur, 'DD/MM/YYYY') : null
    }
  }
}
</script>
